module.exports = __webpack_public_path__ + "img/tree-03-c-leaves.8a7c97d3.png";